import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';

const { selectAudience } = surveyCreationFeature;

export const selectSurveyId = createSelector(
  selectAudience,
  ({ surveyId }) => surveyId,
);

export const selectSurvey = createSelector(
  selectAudience,
  ({ survey }) => survey,
);

export const selectError = createSelector(selectAudience, ({ error }) => error);

export const selectScorePercentage = createSelector(
  selectAudience,
  ({ score }) => score.scorePercentage,
);

export const selectScoreLoading = createSelector(
  selectAudience,
  ({ score }) => score.loading,
);

export const selectScoreError = createSelector(
  selectAudience,
  ({ score }) => score.error,
);

export const selectFeasibilityTotal = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.total,
);

export const selectFeasibilityQuotaGroups = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.quotaGroups,
);

export const selectFeasibilityAudience = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.audience,
);

export const selectFeasibilityLoading = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.loading,
);

export const selectFeasibilityError = createSelector(
  selectAudience,
  ({ feasibility }) => feasibility.error,
);

export const selectLocationSelectionsByQualificationCode = createSelector(
  selectAudience,
  ({ locationSelectionsByQualificationCode }) =>
    locationSelectionsByQualificationCode,
);

export const selectAdvancedTargetingDefinitions = createSelector(
  selectAudience,
  ({ advancedTargetingDefinitions }) => advancedTargetingDefinitions,
);

export const selectHasHydratedAdvancedTargeting = createSelector(
  selectAudience,
  ({ hasHydratedAdvancedTargeting }) => hasHydratedAdvancedTargeting,
);
